'use es6';

import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { PATAGONIA_ADD_PANEL_CATEGORIES_YAML_MAPPING } from 'ContentEditorUI/constants/Sidebar';
import { getActiveSidebarPanel, getPatagoniaSidebarIframeVisible, getSidebarIframeNeedsLoadingIndicator, getSidebarCategory, getSidebarSubCategory, getSidebarSearchQuery, getDefaultSubCategoryMap, getSidebarSearchResultsMap } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import PatagoniaSidebarHeader from 'ContentEditorUI/components/sidebar/PatagoniaSidebarHeader';
import PatagoniaAddModuleMenu from 'ContentEditorUI/components/sidebar/PatagoniaAddModuleMenu';
import { hideSidebarIframeSpinner, showSidebarIframeSpinner, hideSidebarIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import { fetchAddableSections } from 'ContentEditorUI/redux/actions/templateInfoActions';
import { getParentThemePath, getThemePath } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getFetchCustomSectionsRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { requestUninitialized } from 'redux-request-state/util/requestStateCheckers';
import { getCanUseCustomSections } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getPatagoniaAddSidebarCategories, getPatagoniaAddSidebarSubCategories } from 'ContentEditorUI/redux/selectors/sidebarCategorySelectors';
import { updateSelectedSubCategory, updateSelectedCategory } from 'ContentEditorUI/redux/actions/sidebarActions';
import { fetchEmbeds } from 'ContentEditorUI/redux/actions/embedActions';
import { getHasContentEmbedAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getHasSectionsLibraryAccess } from 'ContentEditorUI/redux/selectors/sectionsSelectors';
import SectionsLibraryInfoBanner from 'ContentEditorUI/components/sidebar/SectionsLibraryInfoBanner';
import { getHasSeenSectionsLibraryOnboardingTour } from 'ContentEditorUI/redux/selectors/settingsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  const canUseCustomSections = getCanUseCustomSections(state);
  const customSectionsRequest = getFetchCustomSectionsRequest(state);
  const shouldFetchCustomSections = Boolean(canUseCustomSections && requestUninitialized(customSectionsRequest));
  return {
    activePanel: getActiveSidebarPanel(state),
    sidebarIframeIsVisible: getPatagoniaSidebarIframeVisible(state),
    sidebarIframeNeedsLoadingIndicator: getSidebarIframeNeedsLoadingIndicator(state),
    themePath: getThemePath(state),
    parentThemePath: getParentThemePath(state),
    categories: getPatagoniaAddSidebarCategories(state),
    shouldFetchCustomSections,
    subCategories: getPatagoniaAddSidebarSubCategories(state),
    sidebarSubCategory: getSidebarSubCategory(state),
    sidebarCategory: getSidebarCategory(state),
    defaultSidebarSubCategoryMap: getDefaultSubCategoryMap(state),
    sidebarSearchQuery: getSidebarSearchQuery(state),
    sidebarSearchResultsMap: getSidebarSearchResultsMap(state),
    hasContentEmbedAccess: getHasContentEmbedAccess(state),
    hasSectionsLibraryAccess: getHasSectionsLibraryAccess(state),
    hasSeenSectionsLibraryOnboardingTour: getHasSeenSectionsLibraryOnboardingTour(state)
  };
};
const mapDispatchToProps = {
  fetchAddableSections,
  updateSelectedSubCategory,
  updateSelectedCategory,
  fetchEmbeds
};
class PatagoniaAddPanel extends Component {
  constructor(props) {
    super(props);
    this.handleCategory = this.handleCategory.bind(this);
  }
  componentDidMount() {
    const {
      activePanel,
      sidebarIframeNeedsLoadingIndicator,
      shouldFetchCustomSections,
      themePath,
      sidebarSubCategory,
      sidebarCategory,
      defaultSidebarSubCategoryMap,
      parentThemePath,
      hasContentEmbedAccess
    } = this.props;

    // Make sure to clean up the sidebar iframe an skeleton sidebar spinner on mount if
    // a different tab than "Add" is first shown for the sidebar
    if (!sidebarIframeNeedsLoadingIndicator) {
      hideSidebarIframeSpinner();
    }
    if (activePanel !== SIDEBAR_PANELS.addWidget) {
      hideSidebarIframeWrapperElement();
    }
    if (shouldFetchCustomSections) {
      if (themePath) {
        this.props.fetchAddableSections(themePath);
      }
      if (hasContentEmbedAccess) {
        this.props.fetchEmbeds(themePath, parentThemePath);
      }
    }
    const defaultSidebarSubCategory = defaultSidebarSubCategoryMap[sidebarCategory];
    if (!sidebarSubCategory && defaultSidebarSubCategory) {
      this.props.updateSelectedSubCategory(defaultSidebarSubCategory);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      sidebarIframeNeedsLoadingIndicator,
      sidebarSearchQuery,
      sidebarSearchResultsMap,
      sidebarCategory
    } = this.props;
    if (!prevProps.sidebarIframeNeedsLoadingIndicator && sidebarIframeNeedsLoadingIndicator) {
      showSidebarIframeSpinner();
    } else if (prevProps.sidebarIframeNeedsLoadingIndicator && !sidebarIframeNeedsLoadingIndicator) {
      hideSidebarIframeSpinner();
    }
    if (prevProps.sidebarSearchQuery !== sidebarSearchQuery) {
      const currentCategoryHasResult = sidebarSearchResultsMap[sidebarCategory].count > 0;
      if (!currentCategoryHasResult) {
        const newCategoryWithResult = sidebarSearchResultsMap.firstCategoryWithResult;
        if (newCategoryWithResult && newCategoryWithResult !== sidebarCategory) {
          this.handleCategory(newCategoryWithResult);
        }
      }
    }
  }
  handleCategory(category) {
    const {
      subCategories
    } = this.props;
    const subCategory = subCategories[category][0];
    this.props.updateSelectedCategory(category, subCategory);
  }
  render() {
    const {
      sidebarIframeIsVisible,
      categories,
      sidebarCategory,
      sidebarSearchResultsMap,
      sidebarSearchQuery,
      hasSeenSectionsLibraryOnboardingTour,
      hasSectionsLibraryAccess
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(PatagoniaSidebarHeader, {
        headerText: I18n.text('patagonia.sidebar.addHeader')
      }), hasSectionsLibraryAccess && !hasSeenSectionsLibraryOnboardingTour && /*#__PURE__*/_jsx(SectionsLibraryInfoBanner, {}), /*#__PURE__*/_jsx(PatagoniaAddModuleMenu, {
        sidebarIframeIsVisible: sidebarIframeIsVisible,
        categories: categories,
        categoryYamlMapping: PATAGONIA_ADD_PANEL_CATEGORIES_YAML_MAPPING,
        categorySelected: sidebarCategory,
        handleSelectedCategory: this.handleCategory,
        sidebarSearchResultsMap: sidebarSearchResultsMap,
        sidebarSearchQuery: sidebarSearchQuery
      })]
    });
  }
}
PatagoniaAddPanel.propTypes = {
  sidebarIframeNeedsLoadingIndicator: PropTypes.bool.isRequired,
  activePanel: PropTypes.string,
  sidebarIframeIsVisible: PropTypes.bool.isRequired,
  fetchAddableSections: PropTypes.func.isRequired,
  themePath: PropTypes.string,
  parentThemePath: PropTypes.string,
  categories: PropTypes.array.isRequired,
  shouldFetchCustomSections: PropTypes.bool.isRequired,
  subCategories: PropTypes.object.isRequired,
  sidebarSubCategory: PropTypes.string,
  updateSelectedSubCategory: PropTypes.func.isRequired,
  defaultSidebarSubCategoryMap: PropTypes.object.isRequired,
  sidebarCategory: PropTypes.string.isRequired,
  sidebarSearchQuery: PropTypes.string,
  sidebarSearchResultsMap: PropTypes.object.isRequired,
  updateSelectedCategory: PropTypes.func.isRequired,
  fetchEmbeds: PropTypes.func.isRequired,
  hasContentEmbedAccess: PropTypes.bool.isRequired,
  hasSectionsLibraryAccess: PropTypes.bool.isRequired,
  hasSeenSectionsLibraryOnboardingTour: PropTypes.bool.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(PatagoniaAddPanel);